module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('practitioner-faces', {
    attrs: {
      "practitioner-ids": [_vm.ownerId],
      "size": 18
    }
  }, [_c('small', {
    staticClass: "caption"
  }, [_vm._v("created by")])]), _vm._v(" "), (_vm.spaceIds && _vm.spaceIds.length > 0 && _vm.context === "SPACE") ? _c('space-faces', {
    attrs: {
      "size": _vm.size,
      "space-ids": _vm.spaceIds
    }
  }, [_c('span', {
    staticClass: "caption",
    attrs: {
      "slot": "prepend"
    },
    domProps: {
      "textContent": _vm._s(_vm.ownerTextPrefix)
    },
    slot: "prepend"
  })]) : _vm._e(), _vm._v(" "), (_vm.vertical) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.spaceIds && _vm.spaceIds.length > 0 && _vm.context === "PRACTITIONER") ? _c('space-faces', {
    attrs: {
      "size": _vm.size,
      "space-ids": _vm.spaceIds
    }
  }, [_c('span', {
    staticClass: "caption",
    attrs: {
      "slot": "prepend"
    },
    domProps: {
      "textContent": _vm._s(_vm.sharingTextPrefix)
    },
    slot: "prepend"
  })]) : _vm._e(), _vm._v(" "), (!_vm.spaceIds || _vm.spaceIds.length === 0) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "label": "",
      "color": "amber"
    }
  }, [_vm._v("Private")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db802ec8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SharingInformation.vue
// module id = 1536
// module chunks = 9